<mwe-collapse titleMessageKey="termsOfUse.listOfContents.title">
  <ng-container>
    @for (i of items; track i) {
      <h6>
        <a [mweScrollToTargetOnClick]="getScrollTarget(i)" class="blue pointer">{{ getItemTitleKey(i) | translate }}</a>
      </h6>
    }
  </ng-container>
</mwe-collapse>
<mwe-collapse titleMessageKey="termsOfUse.conditionsOfUse.title" initialState="expanded">
  <div class="overflow-auto scrollbar-thin p-1" tabindex="0">
    <ng-container>
      @for (i of items; track i) {
        <h6 [attr.id]="getItemId(i)">{{ 'termsOfUse.item' + i + '.title' | translate }}</h6>
        <p [innerHTML]="getItemTextKey(i) | translate | safeHtml"></p>
      }
    </ng-container>
  </div>
</mwe-collapse>
